import { eur, fmtDate } from "../lib/api";
import { FORMULAS } from "../lib/labels";

export const QuoteDocument = ({ q, company }) => (
  <div className="print-area mx-auto max-w-3xl rounded-xl bg-white p-6 shadow-sm sm:p-10" data-testid="quote-document">
    <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
      <div>
        <p className="font-display text-xl font-bold text-[#0b2c6b]">{company.name}</p>
        <p className="text-xs text-slate-500">{company.address}</p>
        <p className="text-xs text-slate-500">{company.email} {company.phone && `· ${company.phone}`}</p>
        {company.siret && <p className="text-xs text-slate-500">SIRET : {company.siret}</p>}
      </div>
      <div className="sm:text-right">
        <p className="font-display text-2xl font-bold text-slate-900">DEVIS</p>
        <p className="font-mono-num text-sm">{q.number}</p>
        <p className="text-xs text-slate-500">Émis le {fmtDate(q.created_at)}</p>
      </div>
    </div>
    <div className="mt-8 grid gap-6 text-sm sm:grid-cols-2">
      <div><p className="text-xs font-semibold uppercase text-slate-400">Client</p><p className="font-semibold">{q.client_name}</p><p className="text-slate-600">{q.client_email}</p></div>
      <div><p className="text-xs font-semibold uppercase text-slate-400">Déménagement</p><p>{fmtDate(q.move_date)} · {q.distance_km} km</p><p className="text-slate-600">{q.origin_address} → {q.destination_address}</p></div>
    </div>
    <p className="mt-6 text-sm">Formule <b>{FORMULAS[q.formula]}</b> · Volume <b>{q.volume_m3} m³</b> · {q.truck} · {q.movers} déménageurs</p>
    <table className="mt-4 w-full text-sm">
      <thead><tr className="border-b text-left text-xs uppercase text-slate-400"><th className="py-2">Objet</th><th>Qté</th><th className="text-right">m³</th></tr></thead>
      <tbody>{q.items.map((it, i) => <tr key={i} className="border-b border-slate-100"><td className="py-1.5">{it.name}</td><td>{it.quantity}</td><td className="text-right">{(it.quantity * it.unit_volume_m3).toFixed(2)}</td></tr>)}</tbody>
    </table>
    <div className="ml-auto mt-6 w-full max-w-sm space-y-1.5 text-sm">
      {q.lines.map((l) => <div key={l.label} className="flex justify-between gap-3"><span className="text-slate-600">{l.label}</span><span>{eur(l.amount)}</span></div>)}
      <div className="flex justify-between border-t pt-2"><span>Total HT</span><span>{eur(q.subtotal_ht)}</span></div>
      <div className="flex justify-between"><span>TVA 20 %</span><span>{eur(q.tva)}</span></div>
      <div className="flex justify-between text-base font-bold text-[#0b2c6b]"><span>Total TTC</span><span data-testid="print-total">{eur(q.total_ttc)}</span></div>
      <div className="flex justify-between text-xs text-slate-500"><span>Acompte 30 % à la réservation</span><span>{eur(q.total_ttc * 0.3)}</span></div>
    </div>
    {q.notes && <p className="mt-6 rounded-lg bg-slate-50 p-3 text-sm text-slate-600">{q.notes}</p>}
    <div className="mt-10 grid gap-6 text-xs text-slate-500 sm:grid-cols-2">
      <p>Devis valable 30 jours. Conditions générales de vente applicables.</p>
      {q.decision_by_name ? (
        <p className="border-t pt-2 font-semibold text-slate-700" data-testid="quote-decision-stamp">
          {q.status === "accepte" ? "Bon pour accord" : "Refusé"} en ligne par {q.decision_by_name} le {fmtDate(q.decision_at)}
        </p>
      ) : (
        <p className="border-t pt-2">Bon pour accord — date et signature du client :</p>
      )}
    </div>
  </div>
);
